import { Button } from "./ui/button";
import { ArrowDown, Music2, Sparkles, TrendingUp } from "lucide-react";

export const Hero = () => {
  const scrollToGen = () => {
    const el = document.getElementById("generator");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col items-center justify-center pt-32 pb-24 px-6 overflow-hidden bg-radial-accent grain"
    >
      {/* Background image with heavy overlay */}
      <div
        className="absolute inset-0 opacity-[0.12] bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1708414307683-ca76e8636fc7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtdXNpYyUyMHByb2R1Y2VyJTIwc3R1ZGlvJTIwZGFyayUyMG1vZGUlMjBsaWdodGluZ3xlbnwwfHx8fDE3Nzg2NzcxMDV8MA&ixlib=rb-4.1.0&q=85)",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#050505]/60 to-[#050505]" />

      <div className="relative max-w-5xl mx-auto text-center fade-up">
        <div
          data-testid="hero-pill"
          className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm text-xs font-medium text-zinc-300 mb-8"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-[#CCFF00] animate-pulse" />
          KI-Prompt-Generator für Suno · 100% kostenlos starten
        </div>

        <h1
          data-testid="hero-title"
          className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black tracking-tighter text-white leading-[0.95] neon-text-glow"
        >
          Erstelle{" "}
          <span className="relative inline-block">
            <span className="text-[#CCFF00]">professionelle</span>
            <svg
              className="absolute -bottom-3 left-0 w-full h-3"
              viewBox="0 0 200 12"
              preserveAspectRatio="none"
            >
              <path
                d="M2 8 Q 50 2, 100 6 T 198 6"
                fill="none"
                stroke="#CCFF00"
                strokeWidth="2.5"
                strokeLinecap="round"
              />
            </svg>
          </span>
          <br />
          Suno Prompts in Sekunden
        </h1>

        <p
          data-testid="hero-subtitle"
          className="mt-8 text-lg sm:text-xl text-zinc-400 max-w-2xl mx-auto leading-relaxed"
        >
          Für KI-Musik, Spotify, TikTok und Creator. Von Genre und Stimmung bis
          BPM — fertige Prompts, die wirklich klingen.
        </p>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            data-testid="hero-cta-generate"
            onClick={scrollToGen}
            className="group relative bg-[#CCFF00] hover:bg-[#B3E600] text-black font-bold rounded-full px-8 h-14 text-base transition-all hover:scale-[1.02] pulse-glow"
          >
            <Sparkles className="w-5 h-5 mr-2" strokeWidth={2.5} />
            Prompt generieren
            <ArrowDown className="w-4 h-4 ml-2 transition-transform group-hover:translate-y-0.5" />
          </Button>
          <button
            data-testid="hero-cta-pricing"
            onClick={() => {
              const el = document.getElementById("pricing");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="text-sm font-medium text-zinc-300 hover:text-white px-5 h-14 inline-flex items-center transition-colors"
          >
            Preise ansehen →
          </button>
        </div>

        {/* Trust strip */}
        <div className="mt-20 flex flex-wrap items-center justify-center gap-x-10 gap-y-4 text-xs uppercase tracking-[0.18em] text-zinc-500 font-medium">
          <span className="flex items-center gap-2">
            <Music2 className="w-3.5 h-3.5 text-[#CCFF00]" /> Suno-optimiert
          </span>
          <span className="flex items-center gap-2">
            <TrendingUp className="w-3.5 h-3.5 text-[#CCFF00]" /> TikTok-ready
          </span>
          <span className="flex items-center gap-2">
            <Sparkles className="w-3.5 h-3.5 text-[#CCFF00]" /> Spotify-tauglich
          </span>
        </div>
      </div>
    </section>
  );
};
